
import { cache } from '@/utils/cacheManager'
import $store from '@/store'
import checkPermission from '@/utils/permission'
import { searchConfig, searchConfigMap } from '@/api/user'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import { getUserPrivileges } from '@/api/auth'

export class PricingLCLConfigUtil {
  // 实例集合
  static instanceMap = new Map()
  constructor() {
    this._isAdminOrHQ = MultiCompanyUtil.getInstance().isAdminOrHQ2('PriceLcl')
    this._markupCfgValue = null
    this._needMarkup = parseInt(cache.config.get('PLNeedMarkup')) === 1
    this._markupLocked = this._needMarkup && parseInt(cache.config.get('PLNeedMarkup')) === 1
    this._isApprove = checkPermission(['PLA'])
    this._isInput = checkPermission(['PLI'])
    console.info('cache.config', cache.config)
    if (cache.config.get('PLNeedMarkup')) {
      if (this._needMarkup) {
        if (this._markupLocked) {
          searchConfig({ officeId: $store.getters.currentOfficeId, configName: 'PLMarkupSetting' }).then((res) => {
            const entities = res.data
            for (const entity of entities) {
              if (!entity.hasOwnProperty('overrideable')) { // Config 才有这个字段
                this._markupCfgDef = entity
              } else {
                this._markupCfg = entity
                this.decodeMarkupSetting()
              }
            }
            this._isMarkupSettingsLoaded = true
          })
        }
      }
    }
    // 是否检查审核超时
    if (cache.config.has('PLNeedCheckApprove')) {
      searchConfigMap({ officeId: $store.getters.currentOfficeId,
        configName: 'PLNeedCheckApprove,PLCheckApproveSetting' }).then((res) => {
        const map = res.data
        if (map != null) {
          this._needCheckApprove = map['PLNeedCheckApprove'] === '1'
          if (this._needCheckApprove) {
            this._checkApproveSetting = map['PLCheckApproveSetting']
          }
        }
        this._isCheckApproveSettingsLoaded = true
      })
    }
    getUserPrivileges().then(res => {
      this._privileges = res.data
    })
  }

  static async getInstance() {
    const officeId = $store.getters.currentOfficeId
    let instance = this.instanceMap.get(officeId)
    if (!instance) {
      await cache.load('config')
      instance = new PricingLCLConfigUtil()
      this.instanceMap.set(officeId, instance)
    }
    return instance
  }

  get needMarkup() {
    return this._needMarkup
  }

  set needMarkup(value) {
    this._needMarkup = value
  }

  get markupLocked() {
    return this._markupLocked
  }

  set markupLocked(value) {
    this._markupLocked = value
  }

  get isMarkupSettingsLoaded() {
    return this._isMarkupSettingsLoaded
  }

  set isMarkupSettingsLoaded(value) {
    this._isMarkupSettingsLoaded = value
  }

  get markupCfgDef() {
    return this._markupCfgDef
  }

  set markupCfgDef(value) {
    this._markupCfgDef = value
  }

  get markupCfg() {
    return this._markupCfg
  }

  set markupCfg(value) {
    this._markupCfg = value
  }

  decodeMarkupSetting() {
    if (this._markupCfg && this._markupCfg.value !== '') {
      this._markupCfgValue = JSON.parse(this._markupCfg.value)
    }
  }

  get markupCfgValue() {
    return this._markupCfgValue
  }

  set markupCfgValue(value) {
    this._markupCfgValue = value
  }

  get needCheckApprove() {
    return this._needCheckApprove
  }

  set needCheckApprove(value) {
    this._needCheckApprove = value
  }

  get checkApproveSetting() {
    return this._checkApproveSetting
  }

  set checkApproveSetting(value) {
    this._checkApproveSetting = value
  }

  get isCheckApproveSettingsLoaded() {
    return this._isCheckApproveSettingsLoaded
  }

  set isCheckApproveSettingsLoaded(value) {
    this._isCheckApproveSettingsLoaded = value
  }

  get isApprove() {
    return this._isApprove
  }

  set isApprove(value) {
    this._isApprove = value
  }

  get isInput() {
    return this._isInput
  }

  set isInput(value) {
    this._isInput = value
  }

  get isAdminOrHQ() {
    return this._isAdminOrHQ
  }

  set isAdminOrHQ(value) {
    this._isAdminOrHQ = value
  }

  async getPOLPrivileges() {
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    if (this._isAdminOrHQ) {
      return this.toPolAirPortMap(seaPorts)
    }
    let pts = []
    if (this._privileges) {
      const polPrivileges = this._privileges.filter(privilege => this.filterAllPOL(privilege))
      if (polPrivileges && polPrivileges.length > 0) {
        for (const pg of polPrivileges) {
          if (pg.category === 'PLLA') {
            return this.toPolAirPortMap(seaPorts)
          }
          if (pg.category === 'PLL') {
            const ports = this.getPortByCode(seaPorts, pg.shape.substr(2))
            pts = pts.concat(ports)
          }
        }
      }
    }
    return this.toPolAirPortMap(pts)
  }

  toPolAirPortMap(pts = []) {
    const pgsLMap = {}
    if (!pts || pts.length === 0) {
      return pgsLMap
    }
    for (const pol of pts) {
      const code = pol.countryCode + pol.code
      pgsLMap[code] = this.pol2pg(code)
    }
    return pgsLMap
  }
  /**
   * 查询所有卸货港限制
   */
  filterAllPOD(item) {
    return item.category.substr(0, 3) === 'PLD'
  }

  /**
   * 查询所有起运港限制
   */
  filterAllPOL(item) {
    return item.category.substr(0, 3) === 'PLL'
  }
  pol2pg(countryCodeAndCode) {
    const pg = {}
    pg.category = 'PLL'
    pg.shape = countryCodeAndCode
    return pg
  }
  pod2pg(countryCodeAndCode, point) {
    const pg = {}
    pg.category = 'PLD'
    pg.shape = countryCodeAndCode
    pg.point = point
    return pg
  }
  /**
   * 根据code查找某一港口
   * @param code 港口三位码
   */
  getPortByCode(seaPorts = [], code) { // 按照航线过滤港口
    return seaPorts.filter(item => item.code === code)
  }
}
